import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {MedicalRecordPractitionerModel} from '../model/medicalRecordPractitioner.model';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {Injectable} from '@angular/core';
import {
    ConsultationSummaryConverter
} from '../../../../consultation/consultation/api/model/converter/consultationSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class MedicalRecordPractitionerConverter extends HttpModelConverter<MedicalRecordPractitionerModel>{

    constructor() {
        super();
    }
    protected createInstance(): MedicalRecordPractitionerModel {
        return new MedicalRecordPractitionerModel();
    }

    protected enrichObject(result: MedicalRecordPractitionerModel, src: MedicalRecordPractitionerModel) {
        result.partnerPractitioner = new PartnerSummaryConverter().convert(src.partnerPractitioner);
        result.partner = new PartnerSummaryConverter().convert(src.partner);
    }



}
